import { createServerFn } from "@tanstack/react-start";

import { authMiddleware, mondayBoards } from "@onesolution/middlewares";

import { mondayClient } from "@onesolution/monday/monday";
import { wrapWithUseQuery } from "..";

const handler = createServerFn()
	.middleware([authMiddleware, mondayBoards])
	.handler(async ({ context }) => {
		const userRaw = await mondayClient.query.userInfoByEmail(
			context,
			context.user.email,
		);

		if (!userRaw)
			throw `Can't find current user details. Check monday's user's list ${context.user.email}`;

		const { status, name, ...user } = userRaw;

		return {
			...user,
			email: name,
			role: status,
			favoriteServices: userRaw?.favoriteServices?.linked_item_ids.filter(
				(id) => user.services?.linked_item_ids.includes(id),
			),
			avatar: userRaw?.assets?.[0]?.public_url,
		};
	});

export const getCurrentUserDetails = wrapWithUseQuery("currentUser", handler);
